import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const InvestmentRow = ({ title, description, image, sector }) => {
  return (
    <div className="w-full flex flex-col lg:flex-row items-start justify-center gap-8 py-8 border-t border-gray-300 mx-auto">
      {/* Section Title */}
      <div className="lg:w-2/5 flex items-start">
        <Link to={sector}>
          <h3 className="relative text-xl font-normal text-gray-800 text-center lg:text-left flex gap-2 items-center group">
            <span>{title}</span>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="transition-transform duration-300 group-hover:translate-x-2 rtl:rotate-180 rtl:group-hover:-translate-x-2"
            >
              <path
                d="M12.9688 19.4641C12.8991 19.3945 12.8437 19.3118 12.806 19.2207C12.7682 19.1297 12.7488 19.0321 12.7488 18.9335C12.7488 18.835 12.7682 18.7374 12.806 18.6463C12.8437 18.5553 12.8991 18.4726 12.9688 18.4029L18.4391 12.9335L3.74941 12.9335C3.5505 12.9335 3.35973 12.8545 3.21908 12.7139C3.07843 12.5732 2.99941 12.3824 2.99941 12.1835C2.99941 11.9846 3.07843 11.7938 3.21908 11.6532C3.35973 11.5125 3.5505 11.4335 3.74941 11.4335H18.4391L12.9688 5.96415C12.8281 5.82342 12.749 5.63255 12.749 5.43352C12.749 5.2345 12.8281 5.04363 12.9688 4.9029C13.1095 4.76217 13.3004 4.68311 13.4994 4.68311C13.6984 4.68311 13.8893 4.76217 14.03 4.9029L20.78 11.6529C20.8498 11.7226 20.9051 11.8053 20.9428 11.8963C20.9806 11.9874 21 12.085 21 12.1835C21 12.2821 20.9806 12.3797 20.9428 12.4707C20.9051 12.5618 20.8498 12.6445 20.78 12.7141L14.03 19.4641C13.9604 19.5339 13.8777 19.5892 13.7866 19.6269C13.6956 19.6647 13.598 19.6841 13.4994 19.6841C13.4008 19.6841 13.3033 19.6647 13.2122 19.6269C13.1212 19.5892 13.0384 19.5339 12.9688 19.4641Z"
                fill="#272727"
              />
            </svg>
            <span className="absolute bottom-[-4px] left-1/2 w-0 h-[2px] bg-gray-800 transition-all duration-300 group-hover:w-full group-hover:left-0"></span>
          </h3>
        </Link>
      </div>

      <div className="hidden lg:block w-px bg-gray-300"></div>

      <div className="flex flex-col lg:flex-row lg:w-4/5 gap-8">
        <div className="lg:w-3/5 flex justify-center lg:justify-start">
          <p className="text-gray-600 text-left">{description}</p>
        </div>
        <div className="w-full lg:w-60 lg:h-60 rounded-lg flex justify-center">
          <img
            src={image}
            alt={`${title} illustration`}
            className="w-full max-w-sm max-h-96 h-auto object-cover rounded-lg grayscale hover:grayscale-0"
          />
        </div>
      </div>
    </div>
  );
};

const Investments = () => {
  const { t } = useTranslation();

  const investments = [
    {
      title: t('realEstateTitle'),
      description: t('realEstateDescription'),
      image: 'assets/investment-image1.webp',
      sector: '/realestate',
    },
    {
      title: t('financialSectorTitle'),
      description: t('financialSectorDescription'),
      image: 'assets/investment-image2.webp',
      sector: '/financial',
    },
    {
      title: t('transportTitle'),
      description: t('transportDescription'),
      image: 'assets/investment-image3.webp',
      sector: '/transport',
    },
    {
      title: t('manufacturingTitle'),
      description: t('manufacturingDescription'),
      image: 'assets/investment-image4.webp',
      sector: '/manufacturing',
    },
    {
      title: t('educationTitle'),
      description: t('educationDescription'),
      image: 'assets/investment-image5.webp',
      sector: '/education',
    },
    {
      title: t('energyAndMaterialTitle'),
      description: t('energyAndMaterialDescription'),
      image: 'assets/investment-image6.webp',
      sector: '/energyandmaterial',
    },
    {
      title: t('foodSectorTitle'),
      description: t('foodSectorDescription'),
      image: 'assets/investment-image-7.webp',
      sector: '/food',
    },
  ];

  return (
    <div className="bg-main-background-color flex w-full items-center justify-center py-16 px-4">
      <div className="flex flex-col w-full max-w-7xl">
        <h2 className="text-3xl font-normal text-gray-900 mb-10 w-full">
          <sup>(7)</sup>  {t('investmentsTitle')}
        </h2>
        {investments.map((investment, index) => (
          <InvestmentRow
            key={index}
            title={investment.title}
            description={investment.description}
            image={investment.image}
            sector={investment.sector}
          />
        ))}
      </div>
    </div>
  );
};

export default Investments;
